import { alpha, Box, Drawer, styled } from '@mui/material';

import { DrawerAction, DrawerContent } from '../../Layout';

export const StyledDrawer = styled(Drawer)(({ theme }) => ({
  ':not(MuiPopover-root):not(.MuiMenu-root)': {
    '.MuiModal-backdrop': {
      backgroundColor: alpha(theme.palette.grey[1000], 0.5),
    },
  },
}));

export const StyledDrawerContent = styled(DrawerContent)(({ theme }) => ({
  position: 'relative',
  [theme.breakpoints.down('lg')]: {
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,

    '.FileThumbnailContainer': {
      borderRadius: 0,
      '.PDFContainer': {
        padding: 0,
      },
    },
  },
}));

export const ScrollFader = styled(Box)(({ theme }) => ({
  background: `linear-gradient(transparent, ${theme.palette.background.paper})`,
  position: 'absolute',
  bottom: 0,
  left: 0,
  height: theme.spacing(8),
  width: '100%',
}));

export const StyledDrawerAction = styled(DrawerAction)(({ theme }) => ({
  padding: theme.spacing(2),

  [theme.breakpoints.up('lg')]: {
    paddingTop: 0,
  },
}));

export const DisclaimerBox = styled(Box)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  paddingBottom: theme.spacing(6),
  maxWidth: 360,
}));
